import { UseCase } from '@/shared/application/UseCase';
import { EffectiveDatesResponse } from '@/application/shared/domain/EffectiveDatesResponse';
import { EnrollmentRepository } from '@/application/shared/domain/EnrollmentRepository';
import { APPLICATION_TYPES } from '@hfc/common';
import { SfApiResponse } from '@hfc/ui-core';

export class GetEffectiveDatesUseCase implements UseCase<APPLICATION_TYPES, SfApiResponse<Array<EffectiveDatesResponse>>> {

  private repository: EnrollmentRepository;

  public constructor (repository: EnrollmentRepository) {
    this.repository = repository;
  }

  public async run (quoteType: APPLICATION_TYPES): Promise<SfApiResponse<Array<EffectiveDatesResponse>>> {
    return await this.repository.getEffectiveDates(quoteType);
  }

}
